export const setSessionStorageItem = (key: string, value: string) => {
  return sessionStorage.setItem(key, value);
};
